import moment from "moment";
import React from "react";
import { connect, ConnectedProps } from "react-redux";
import { RouteComponentProps, withRouter } from "react-router";
import { bindActionCreators, Dispatch } from "redux";
import styled from "styled-components";
import Button from "sweet-web/components/universal/Button";
import OutlineButton from "sweet-web/components/universal/Button/OutlineButton";
import TextButton from "sweet-web/components/universal/Button/TextButton";
import { fadeIn } from "sweet-web/lib/animations";
import { colors } from "sweet-web/lib/styles";
import { RootState } from "sweet-web/redux";
import {
  CancelBooking,
  ReviseBooking,
  setEditingBooking,
  SubmitProposal
} from "sweet-web/redux/booking/actions";
import * as selectors from "sweet-web/redux/selectors";

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  margin-top: 0;
`;

const buttonStyle = {};

type OwnProps = {};

type Props = OwnProps & RouteComponentProps & ConnectedProps<typeof connector>;

const Controls: React.FC<Props> = props => {
  const { chatId } = props.match.params as { chatId: string };
  const {
    userType,
    booking,
    isSubmittingProposal,
    errorSubmittingProposal,
    isRevisingBooking,
    errorRevisingBooking,
    editing
  } = props;

  const cancelInquiry = async () => {
    if (
      window.confirm(
        "Are you sure you want to end this inquiry? You will lose this communication and the booking"
      )
    ) {
      props.history.push(`/c`);
      await props.CancelBooking(booking.id);
    }
  };

  const reviseBooking = async () => {
    await props.ReviseBooking(booking.id);
  };

  const cancelProposal = async () => {
    if (
      window.confirm(
        "Are you sure you want to cancel this proposal? You will not be able to undo this"
      )
    ) {
      props.history.push(`/c`);
      await props.CancelBooking(booking.id);
    }
  };

  const submitProposal = async () => {
    await props.SubmitProposal(booking.id);
  };

  const cancelBooking = async () => {
    // TODO
  };

  const confirmBooking = async () => {
    props.history.push(`/b/${booking.id}/pay`);
  };

  const stopEditing = async () => {
    props.setEditingBooking(false);
  };

  return (
    <Wrapper>
      {booking.status === "INQUIRY" && userType === "VENUE" && (
        <React.Fragment>
          <Button
            title={`Submit Proposal`}
            onClick={submitProposal}
            style={buttonStyle}
            loading={isSubmittingProposal}
            error={errorSubmittingProposal}
          />
          <TextButton
            small={true}
            color={"gray"}
            title={`Cancel Inquiry`}
            onClick={cancelInquiry}
            style={buttonStyle}
          />
        </React.Fragment>
      )}
      {booking.status === "INQUIRY" && userType === "USER" && (
        <React.Fragment>
          <Button
            title={`Revise Inquiry`}
            onClick={reviseBooking}
            style={buttonStyle}
            loading={isRevisingBooking}
            error={errorRevisingBooking}
          />
          <TextButton
            small={true}
            color={"gray"}
            title={`Cancel Inquiry`}
            onClick={cancelInquiry}
            style={buttonStyle}
          />
        </React.Fragment>
      )}
      {booking.status === "PROPOSED" && userType === "VENUE" && (
        <React.Fragment>
          <Button
            title={`Revise Proposal`}
            onClick={submitProposal}
            style={buttonStyle}
            loading={isSubmittingProposal}
          />
          <TextButton
            small={true}
            color={"gray"}
            title={`Cancel Proposal`}
            onClick={cancelProposal}
            style={buttonStyle}
          />
        </React.Fragment>
      )}
      {booking.status === "PROPOSED" && userType === "USER" && !editing && (
        <React.Fragment>
          <Button
            title={`Confirm Booking`}
            onClick={confirmBooking}
            style={buttonStyle}
          />
          <TextButton
            small={true}
            color={"gray"}
            title={`Cancel Inquiry`}
            onClick={cancelInquiry}
            style={buttonStyle}
          />
        </React.Fragment>
      )}
      {booking.status === "PROPOSED" && userType === "USER" && editing && (
        <React.Fragment>
          <Button
            title={`Propose Revision`}
            onClick={reviseBooking}
            style={buttonStyle}
            error={errorRevisingBooking}
          />

          <OutlineButton
            color={"gray"}
            title={`Cancel Revision`}
            onClick={stopEditing}
            style={buttonStyle}
          />
        </React.Fragment>
      )}
      {booking.status === "CONFIRMED" && userType === "VENUE" && !editing && (
        <React.Fragment>
          <OutlineButton
            color={"gray"}
            title={`Cancel Booking`}
            onClick={cancelBooking}
            style={buttonStyle}
          />
        </React.Fragment>
      )}
      {booking.status === "CONFIRMED" && userType === "USER" && !editing && (
        <React.Fragment>
          <OutlineButton
            color={"gray"}
            title={`Cancel Booking`}
            onClick={cancelBooking}
            style={buttonStyle}
          />
        </React.Fragment>
      )}
      {booking.status === "COMPLETED" && userType === "VENUE" && (
        <React.Fragment>
          {/* <OutlineButton
            color={"gray"}
            title={`Request Additional Payment`}
            onClick={requestPayment}
            style={buttonStyle}
          /> */}
        </React.Fragment>
      )}
      {booking.status === "COMPLETED" && userType === "USER" && (
        <React.Fragment>
          {/* <OutlineButton
            color={"gray"}
            title={`Request Refund`}
            onClick={requestRefund}
            style={buttonStyle}
          /> */}
        </React.Fragment>
      )}
    </Wrapper>
  );
};

const mapState = (state: RootState, ownProps: RouteComponentProps) => {
  const { chatId } = ownProps.match.params as { chatId: string };

  return {
    chat: selectors.chat(chatId)(state),
    userType: selectors.userType(state),
    booking: selectors.getBookingByChat(chatId)(state),
    errorSubmittingProposal: selectors.errorSubmittingProposal(state),
    isSubmittingProposal: selectors.isSubmittingProposal(state),
    isRevisingBooking: selectors.isRevisingBooking(state),
    errorRevisingBooking: selectors.errorRevisingBooking(state),
    editing: selectors.editingBooking(state)
  };
};
const mapDispatch = (dispatch: Dispatch) =>
  bindActionCreators(
    {
      CancelBooking,
      SubmitProposal,
      ReviseBooking,
      setEditingBooking
    },
    dispatch
  );
const connector = connect(mapState, mapDispatch);

export default withRouter(connector(Controls));
